(function() {
  'use strict';
  
  angular
    .module('plugins.q-and-a')
    .controller('QAndAResultShownController', QAndAResultShownController);
  
  QAndAResultShownController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function QAndAResultShownController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('QAndAResultShownController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.questions = []

    activate();
    
    function activate() {
      var poll = $scope.poll
        , result = $scope.result;

      // Questions saved on result maintain their upvotes - they need to be
      // wiped and recalculated
      result.responses.forEach(function(response){
        response.data.upvotes = [];
      })

      // Rebuild question list and assign upvotes
      result.responses.forEach(function(response) {
        if (response.data.question)
          vm.questions.push(response);
        else
          findAndUpvote(response.data.upvote, response.user)
      })
  
      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }
    
    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      if (response.data.question)
        vm.questions.push(response);
      else
        findAndUpvote(response.data.upvote, response.user)
    }

    function findAndUpvote(questionId, userId) {
      _.each(vm.questions, function(q) {
        if (q._id === questionId) {
          var index = q.data.upvotes.indexOf(userId)
          if (index === -1) {
            q.data.upvotes.push(userId);
          } else {
            q.data.upvotes.splice(index, 1)
          }
        }
      })
    }
    
  }
  
})();